import { useMemo } from "react";

import { buildZoneAreaPath, computePoints } from "./utils";

export type SparklineZoneOverlayProps = {
    data: readonly number[];
    zoneStartIndex: number;
    zoneColor: string;
    width: number;
    height: number;
    min?: number;
    max?: number;
};

export const SparklineZoneOverlay = ({
    data,
    zoneStartIndex,
    zoneColor,
    width,
    height,
    min,
    max,
}: SparklineZoneOverlayProps) => {
    const zonePath = useMemo(() => {
        if (zoneStartIndex <= 0 || zoneStartIndex >= data.length || data.length < 2) {
            return null;
        }

        const allPoints = computePoints(data, width, height, min, max);

        return buildZoneAreaPath(allPoints.slice(zoneStartIndex), height);
    }, [data, zoneStartIndex, width, height, min, max]);

    if (!zonePath) {
        return null;
    }

    return (
        <svg
            width="100%"
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            preserveAspectRatio="none"
            style={{ position: "absolute", top: 0, left: 0, pointerEvents: "none" }}
        >
            <path
                d={zonePath}
                fill={zoneColor}
            />
        </svg>
    );
};
